import { Box, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { LIGHT_TEXT } = COLORS;

export const MainCont = styled(Box)(() => ({}));

export const NoData = styled(Typography)(() => ({
  fontSize: 20,
  color: LIGHT_TEXT,
  textAlign: 'center',
  marginTop: 30,
}));
